module.exports = __webpack_public_path__ + "img/Coin.e11d6b9b.png";